
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calculator, ArrowRight, Sparkles } from "lucide-react";
import { ValuationModal } from "./ValuationModal";
import { motion } from "framer-motion";

export function ValuationCard() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <motion.div 
        className="action-card overflow-hidden bg-gradient-to-br from-background to-gold/5 dark:from-background dark:to-gold/10 h-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7 }}
        whileHover={{ y: -5 }}
      >
        <div className="h-full flex flex-col justify-between p-6">
          <div>
            <h2 className="text-2xl font-bold mb-4 flex items-center text-gold">
              <Calculator className="h-5 w-5 mr-2" />
              Calcola Valore
            </h2>
            <p className="mb-6 text-foreground/80">
              Calcola rapidamente il valore dei tuoi metalli preziosi in base a peso e purezza. Ottieni una stima precisa basata sui prezzi di mercato attuali.
            </p>
          </div>
          <Button 
            className="bg-gold hover:bg-gold-dark text-white hover:scale-105 transition-transform font-medium"
            onClick={openModal}
          >
            <Sparkles className="h-4 w-4 mr-2" />
            Valuta Ora
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </motion.div>

      <ValuationModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
      />
    </>
  );
}
